// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\Issue\ApiIssue.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Berth, BerthData, BerthOptions } from 'data/models/Berth';
import { BerthClosure, BerthClosureData, BerthClosureOptions } from 'data/models/BerthClosure';
import { BerthReservation, BerthReservationData, BerthReservationOptions } from 'data/models/BerthReservation';
import { PilotJobOrder, PilotJobOrderData, PilotJobOrderOptions } from 'data/models/PilotJobOrder';
import { ScheduleDateEntity, ScheduleDateEntityData, ScheduleDateEntityOptions } from 'data/models/ScheduleDateEntity';
import { ScheduleDateEvent, ScheduleDateEventData, ScheduleDateEventOptions } from 'data/models/ScheduleDateEvent';
import { DiscrepantScheduleDateField, IssueSeverity } from 'server/enums/Issue';

// IssueData is the class that Issue serializes to/from
export interface IssueData {
    Id : number;
	
    Berth : BerthData | null;
    BerthClosure : BerthClosureData | null;
    BerthClosureId : number;
    BerthId : number;
    BerthReservation : BerthReservationData | null;
    BerthReservationBerthClosure : BerthClosureData | null;
    BerthReservationBerthClosureId : number;
    BerthReservationId : number;
    EnteredDate : ScheduleDateEventData | null;
    EnteredDateId : number;
    OtherClosure : BerthClosureData | null;
    OtherClosureId : number;
    OtherReservation : BerthReservationData | null;
    OtherReservationId : number;
    PilotJobOrder : PilotJobOrderData | null;
    PilotJobOrderId : number;
    ScheduleDate : ScheduleDateEntityData | null;
    ScheduleDateId : number;
	
    ConfirmDate : /* ISO8601 */ string;
    DetectDate : /* ISO8601 */ string;
    DiscrepantDateField : DiscrepantScheduleDateField;
    Severity : IssueSeverity;
    Type : string | null;
}

// IssueOptions is the class which may be passed to the Issue constructor to define optional initial data values
export interface IssueOptions {
    Id : number;
	
    Berth? : BerthOptions | null;
    BerthClosure? : BerthClosureOptions | null;
    BerthClosureId? : number;
    BerthId? : number;
    BerthReservation? : BerthReservationOptions | null;
    BerthReservationBerthClosure? : BerthClosureOptions | null;
    BerthReservationBerthClosureId? : number;
    BerthReservationId? : number;
    EnteredDate? : ScheduleDateEventOptions | null;
    EnteredDateId? : number;
    OtherClosure? : BerthClosureOptions | null;
    OtherClosureId? : number;
    OtherReservation? : BerthReservationOptions | null;
    OtherReservationId? : number;
    PilotJobOrder? : PilotJobOrderOptions | null;
    PilotJobOrderId? : number;
    ScheduleDate? : ScheduleDateEntityOptions | null;
    ScheduleDateId? : number;
	
    ConfirmDate? : /* ISO8601 */ string;
    DetectDate? : /* ISO8601 */ string;
    DiscrepantDateField? : DiscrepantScheduleDateField;
    Severity? : IssueSeverity;
    Type? : string | null;
}

export class Issue {
    public Id : DataSignal<number>;
	
    public Berth : DataSignal<Berth | null>;
    public BerthClosure : DataSignal<BerthClosure | null>;
    public BerthClosureId : DataSignal<number>;
    public BerthId : DataSignal<number>;
    public BerthReservation : DataSignal<BerthReservation | null>;
    public BerthReservationBerthClosure : DataSignal<BerthClosure | null>;
    public BerthReservationBerthClosureId : DataSignal<number>;
    public BerthReservationId : DataSignal<number>;
    public EnteredDate : DataSignal<ScheduleDateEvent | null>;
    public EnteredDateId : DataSignal<number>;
    public OtherClosure : DataSignal<BerthClosure | null>;
    public OtherClosureId : DataSignal<number>;
    public OtherReservation : DataSignal<BerthReservation | null>;
    public OtherReservationId : DataSignal<number>;
    public PilotJobOrder : DataSignal<PilotJobOrder | null>;
    public PilotJobOrderId : DataSignal<number>;
    public ScheduleDate : DataSignal<ScheduleDateEntity | null>;
    public ScheduleDateId : DataSignal<number>;
	
    public ConfirmDate : DataSignal<TZDate>;
    public DetectDate : DataSignal<TZDate>;
    public DiscrepantDateField : DataSignal<DiscrepantScheduleDateField>;
    public Severity : DataSignal<IssueSeverity>;
    public Type : DataSignal<string | null>;

    constructor();
    constructor(data : IssueOptions);
    constructor(data: IssueOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.Berth = S.value<Berth | null>(null);
        this.BerthClosure = S.value<BerthClosure | null>(null);
        this.BerthClosureId = jsonableObservable(S.value<number>(data && data.BerthClosureId !== undefined ? data.BerthClosureId : 0));
        this.BerthId = jsonableObservable(S.value<number>(data && data.BerthId !== undefined ? data.BerthId : 0));
        this.BerthReservation = S.value<BerthReservation | null>(null);
        this.BerthReservationBerthClosure = S.value<BerthClosure | null>(null);
        this.BerthReservationBerthClosureId = jsonableObservable(S.value<number>(data && data.BerthReservationBerthClosureId !== undefined ? data.BerthReservationBerthClosureId : 0));
        this.BerthReservationId = jsonableObservable(S.value<number>(data && data.BerthReservationId !== undefined ? data.BerthReservationId : 0));
        this.EnteredDate = S.value<ScheduleDateEvent | null>(null);
        this.EnteredDateId = jsonableObservable(S.value<number>(data && data.EnteredDateId !== undefined ? data.EnteredDateId : 0));
        this.OtherClosure = S.value<BerthClosure | null>(null);
        this.OtherClosureId = jsonableObservable(S.value<number>(data && data.OtherClosureId !== undefined ? data.OtherClosureId : 0));
        this.OtherReservation = S.value<BerthReservation | null>(null);
        this.OtherReservationId = jsonableObservable(S.value<number>(data && data.OtherReservationId !== undefined ? data.OtherReservationId : 0));
        this.PilotJobOrder = S.value<PilotJobOrder | null>(null);
        this.PilotJobOrderId = jsonableObservable(S.value<number>(data && data.PilotJobOrderId !== undefined ? data.PilotJobOrderId : 0));
        this.ScheduleDate = S.value<ScheduleDateEntity | null>(null);
        this.ScheduleDateId = jsonableObservable(S.value<number>(data && data.ScheduleDateId !== undefined ? data.ScheduleDateId : 0));
	    
        this.ConfirmDate = jsonableObservable(S.value<TZDate>(data && data.ConfirmDate !== undefined ? new TZDate(data.ConfirmDate) : new TZDate(0), TZDate.eq));
        this.DetectDate = jsonableObservable(S.value<TZDate>(data && data.DetectDate !== undefined ? new TZDate(data.DetectDate) : new TZDate(0), TZDate.eq));
        this.DiscrepantDateField = jsonableObservable(S.value<DiscrepantScheduleDateField>(data && data.DiscrepantDateField !== undefined ? data.DiscrepantDateField : 0));
        this.Severity = jsonableObservable(S.value<IssueSeverity>(data && data.Severity !== undefined ? data.Severity : 0));
        this.Type = jsonableObservable(S.value<string | null>(data && data.Type !== undefined ? data.Type : null));
    }

    static key(obj : Issue) {
        return obj.Id();
    }
    
    static dataKey(obj : IssueOptions) {
        return obj.Id;
    }

    static update(obj : Issue, data : IssueOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.BerthClosureId !== undefined) obj.BerthClosureId(data.BerthClosureId);
            if (data.BerthId !== undefined) obj.BerthId(data.BerthId);
            if (data.BerthReservationBerthClosureId !== undefined) obj.BerthReservationBerthClosureId(data.BerthReservationBerthClosureId);
            if (data.BerthReservationId !== undefined) obj.BerthReservationId(data.BerthReservationId);
            if (data.EnteredDateId !== undefined) obj.EnteredDateId(data.EnteredDateId);
            if (data.OtherClosureId !== undefined) obj.OtherClosureId(data.OtherClosureId);
            if (data.OtherReservationId !== undefined) obj.OtherReservationId(data.OtherReservationId);
            if (data.PilotJobOrderId !== undefined) obj.PilotJobOrderId(data.PilotJobOrderId);
            if (data.ScheduleDateId !== undefined) obj.ScheduleDateId(data.ScheduleDateId);
	        
            if (data.ConfirmDate !== undefined) obj.ConfirmDate(new TZDate(data.ConfirmDate));
            if (data.DetectDate !== undefined) obj.DetectDate(new TZDate(data.DetectDate));
            if (data.DiscrepantDateField !== undefined) obj.DiscrepantDateField(data.DiscrepantDateField);
            if (data.Severity !== undefined) obj.Severity(data.Severity);
            if (data.Type !== undefined) obj.Type(data.Type);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Issue.ts